module.exports = {
  urls: {
    app: 'https://app.hackedu.dev',
    blog: 'https://blog.hackedu.com',
    cdn: 'https://cdn.hackedu.io',
    control: 'https://control.hackedu.dev',
    hacker: 'https://platform.hackedu.dev/hacker/v1',
    quiz: 'https://platform.hackedu.dev/quiz/v1',
    samy: 'https://samy.hackedu.dev',
    testengine: 'https://platform.hackedu.dev/test-engine/v1',
    www: 'https://www.hackedu.dev',
  },
  aws: {
    region: 'us-east-1',
    identityPoolId: 'us-east-1:46517db2-5331-4aa7-9354-3cbd9aad76b8',
  },
  cognito: {
    authData: {
      ClientId: 'i78kjordr8ijhnnhf92sm5p24',
      AppWebDomain: 'auth.hackedu.dev',
      TokenScopesArray: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      RedirectUriSignIn: 'https://app.hackedu.dev/auth',
      RedirectUriSignOut: 'https://app.hackedu.dev',
      UserPoolId: 'us-east-1_SlBDp9xy2',
      AdvancedSecurityDataCollectionFlag: false,
    },
  },
  saml: {
    checkDomainAssociationUri: 'https://platform.hackedu.dev/auth/v1/domain',
  },
  segment: {
    key: 'FnZoB09pnPOAuGdsdyaNNu68prLpIsLN',
  },
  stripe: {
    key: 'pk_test_WysZSWBVn6L0XNh4fUqx3NFZ',
  },
}
